import { getContestByIdFromStore } from '../contest-store'

function contestIsActive(contestId) {
  const contest = getContestByIdFromStore(contestId)
  return contest.active
}

export { contestIsActive }